// Utilities
import { defineStore } from 'pinia'
import {useStorage} from "@vueuse/core";

export const useApplicationStore = defineStore('app', {
  state: () => ({
    migrationNoticeWasDismissed: useStorage('migration-notice-v2', true),
  }),
})
